<div class="modal-body">
  <div class="alert alert-success" role="status">
    <strong>{{ personName }}</strong> has been added to the roster and needs verification.
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="returnToRoster.emit()">Return to Roster</button>
  <button type="button" class="btn btn-outline-primary" (click)="addAnother.emit()">Add Another Staff Member</button>
  <button type="button" class="btn btn-primary" (click)="reviewNewStaff.emit()">Review New Staff Member</button>
</div>
